/**
 * @generated SignedSource<<5b132c1dd9274f4d21c53773597134c5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PostNoteToSlackInput = {
  clientMutationId?: string | null;
  includeAiSummary?: boolean | null;
  message: string;
  noteId: string;
  slackChannel?: string | null;
  slackMember?: string | null;
  teamId?: string | null;
};
export type SendNotesModalPostToSlackMutation$variables = {
  input: PostNoteToSlackInput;
};
export type SendNotesModalPostToSlackMutation$data = {
  readonly postNoteToSlack: {
    readonly ok: boolean;
  } | null;
};
export type SendNotesModalPostToSlackMutation = {
  response: SendNotesModalPostToSlackMutation$data;
  variables: SendNotesModalPostToSlackMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PostNoteToSlackPayload",
    "kind": "LinkedField",
    "name": "postNoteToSlack",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SendNotesModalPostToSlackMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SendNotesModalPostToSlackMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "485b73f2ddd04d7cc188e813fb137b06",
    "id": null,
    "metadata": {},
    "name": "SendNotesModalPostToSlackMutation",
    "operationKind": "mutation",
    "text": "mutation SendNotesModalPostToSlackMutation(\n  $input: PostNoteToSlackInput!\n) {\n  postNoteToSlack(input: $input) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "b7fc6bea2dc3dd350fb8623a3c8ed982";

export default node;
